import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const regionStatusSchema = z.enum(["needs_reauth", "outdated", "unknown", "ok"]);

export type SpApiRegionStatus = z.infer<typeof regionStatusSchema>;

const regionSchema = z.object({
  status: regionStatusSchema,
  missing_roles: z.array(z.string()).default([]),
  seller_id_mismatch: z.boolean().default(false),
});

const responseSchema = z.object({
  sp_api_fawcett_credential_disabled: z.boolean(),
  sp_api_authorized: z.boolean(),
  sp_api_grant_outdated: z.boolean().default(false),
  sp_api_missing_roles: z.array(z.string()).default([]),
  seller_id_mismatch_detected: z.boolean(),
  regions: z.record(regionSchema).default({}),
});

export const spApiCredentialCheckDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "checkSpApiCredential",
    method: "get",
    path: "/sp_api_credential_check",
    parameters: [
      {
        name: "marketplace",
        type: "Query",
        schema: z.string().optional(),
      },
    ],
    status: 200,
    response: responseSchema,
  }).build(),
);
